export default __webpack_public_path__ + "static/media/success-draft.8be8cc00.png";